import React from 'react';
import Loader from '../common/loader';

function CardBlockLoaderWrapper({ isLoading = true }) {
  return (
    <div className={`main_loader  ${isLoading ? 'show_block' : 'hide_block'}`}>
      <div className='loader-mid'>
        <div className='card-block-loader'>
          <Loader />
        </div>
      </div>
    </div>
  );
}

export default CardBlockLoaderWrapper;



// WEBPACK FOOTER //
// ./src/components/CardBlockLoaderWrapper.jsx